import React, { useState } from 'react';

import { TextField } from '@mui/material';

function FilterGpoName({
    setGpoName,
	GpoName,
}) {

	const [Focus, setFocus] = useState(false);

    function changeProjectType(event) {
        setGpoName(event.target.value?event.target.value:null)
	}

    return (
        <>
            <div>
                <div className="flex gap-3">
                    <div className="grow">
                        <div className="lightT">
                            <TextField onFocus={() => setFocus(true)} onChange={(event, value) => changeProjectType(event)} id="outlined-basic" value={GpoName} label="GPO Name" variant="outlined" />
                            {GpoName == null && Focus && (
								<small className="text-red-600 ">
									GPO Name is required
								</small>
							)}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FilterGpoName;
